import ApiClient from './ApiClient';

class IframeAppsAPI extends ApiClient {
  constructor() {
    super('iframe_apps', { accountScoped: true });
  }
}

export default new IframeAppsAPI();
